<!--
@name 艺术设计与管理硕士
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <div class="content">
      <!--  专业介绍 -->
      <div class="cont-item">
        <div class="title-image">专业介绍</div>
        <div class="selector-indent">
          随着全球艺术、文化及创意产业的蓬勃发展，设计与管理相结合的需求日益凸显。企业更需要能够将创新与设计转化为服务，并有效管理与经营的人才。因此，MADA(艺术设计与管理硕士)项目应运而生，它融合了艺术学、设计学、管理学等多个学科的知识体系，注重在艺术与设计领域的战略规划、项目管理、市场营销、品牌运营方面的发展，其目标在于培养拥有深厚理论基础和创新能力，同时结合管理学知识，提升项目管理、市场营销、品牌策划等能力复合型人才。
        </div>
      </div>
      <!--  专业介绍 -->
      <!--培养目标 -->
      <div class="cont-item">
        <div class="title-image">培养目标</div>
        <p>培养艺术感知能力、创新思维和设计能力，能够在艺术与设计领域进行深入的研究和实践；</p>
        <p>掌握现代管理理论与方法，包括项目管理、市场营销、品牌策划等，拓宽职业方向；</p>
        <p>培养跨学科整合能力，能够将艺术与设计知识与管理学知识相结合，为艺术、设计、文化及创意产业提供创新性的解决方案；</p>
        <p>通过实践项目、实习、案例分析等方式，提升实践应用能力，提升管理与经营能力和团队协作精神。</p>
      </div>
      <!-- 培养目标 -->
      <!--  项目优势 -->
      <div class="cont-item">
        <div class="title-image">项目优势</div>
        <div class="advantage">
          <p class="advantage-title">系统化跨界融合，打造复合型管理人才</p>
          <p>
            -全面系统知识体系：将艺术设计的美学思维与商业管理的实战策略紧密结合，提供既具创意又具执行力的知识体系，将艺术设计价值转化为市场优势。</p>
          <p>
            -多元视角的解决问题能力：通过艺术设计、商业管理、市场营销等多领域知识形成多元化的视角，分析行业趋势，精准把握消费需求，助力企业突破发展瓶颈。</p>
          <p class="advantage-title">精准对接行业，提升服务品质</p>
          <p>
            -美学设计与服务理念：着重美学与艺术设计，为艺术、文化及创意领域提供前沿的设计理念和方法，融入服务流程和产品设计中，提升体验。</p>
          <p>-服务与体验设计：以用户为中心的设计理念，设计优质的服务流程和体验场景，提升机构的品牌形象和客户忠诚度。</p>
          <p class="advantage-title">强化品牌策划与营销策略</p>
          <p>
            -品牌塑造与传播：涵盖品牌策划与营销策列的核心内容，提升企业与品牌鲜明且有影响力的形象，增加高效传播品牌信息的方法。</p>
          <p>-精准营销策略：提升数据分析能力和市场洞察能力，制定精准有效的营销策略。创造企业价值。</p>
          <p class="advantage-title">提升给项目管理与跨领域协作能力</p>
          <p>提升项目管理能力，培养团队协作精神和跨领域沟通能力，推动企业的持续发展。</p>
        </div>
      </div>
      <!-- 项目优势 -->
      <!--培养方式 -->
      <div class="cont-item">
        <div class="title-image">培养方式</div>
        <p>
          法国布雷斯特高等商学院艺术设计与管理硕士专业采用线上与线下相结合，自主学习和毕业论文相结合的方式进行为期1.5年的学习。毕业季时组织学生集体去法国参加研修及毕业典礼。</p>
      </div>
      <!-- 培养方式 -->
      <!-- 课程设置 -->
      <div class="cont-item">
        <div class="title-image">课程设置</div>
        <img src="@/assets/images/personRain/madm-course.jpg" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/madm-course01.jpg" alt="" class="course-img"/>
      </div>
      <!-- 课程设置 -->
      <!-- 部分师资 -->
      <div class="cont-item">
        <div class="title-image">师资力量</div>
        <p>
          何洁：原清华大学美术学院副院长、清华大学艺术与设计实验教学中心主任、清华大学美术图书馆馆长，教育部艺术类教学指导委员会委员、艺术设计分委员会副主任，中国广告协会副会长、学术委员会副主任。</p>
        <p>
          郝凝辉：中央美术学院设计学院院长、教务处长、二级教授、博土生导师、校学术委员会委员，教育部青年“长江学者”国家社科基金重大课题首席专家，福布斯中国设计师TOP10、光华龙腾奖，中国设计业十大杰出青年，奥运会录观设施设计师，中国十佳设计教育工作者、教育部产教融合教授，首个在中国开设文创产品设计专业方向的学者，曾在美国纽约策划天下华灯文创产品展（纽约花旗球场展出)。</p>
        <p>
          靳军：中央美术学院设计学院教授、副院长，美国波士顿大学艺术设计硕士，清华大学电子工程学士。1998年参与创办“哈佛中国论坛”担任艺术总监，2016年“北京媒体艺术双年展”策展人，2015年主持创作“2015艺术北京十周年”建筑影像投影秀，2015年参与策划“B3动态影像双年展-北京、法兰克福。</p>
        <p>
          范迪安：中央美术学院院长，教授，博土生导师，兼任中国美术家协会主底，中国文艺评论家协会副主席，教育部艺术教育委员会副主任，中央文史研究馆馆员，北京美术家协会丰席，全国政协委员。长期从事20世纪中国美术研究、当代艺术评论与展览策划、艺术博物馆学研究。</p>
        <p>
          卢征远：中央美术学院造型学科基础部副主任，中央美术学院教授、硕士研究生导师，创作多具有代表性的公共艺术作品，多次参加国家重大艺术项目创作；策划多场具有一定民响力的艺术展，艺术创作注重表达内在的精神力量。</p>
        <p>
          余丁：中央美术学院艺术管理与教育学院院长、中央美术学院国家艺术与文化政策研究所所长，中央美术学院艺术管理学系创始主任、教授、博土生导师，长期致力于西方美术史的译介和研究工作，专注于艺术管理学研究与学科建设，教育部“十一五规划”教材《艺术管理学概论》主编、教育部国家哲学社会学重大攻关课颗《艺术学科发展和艺术院校人才培养模式研究》首席专家。</p>
        <p>
          于婉莹：清华大学美术学院社会美育研究所副所长，清华青岛艺术与科学创新研究院美育实验室副主任，副教授，硕士生导师，清华大学仲英青年学者，美术学博士。</p>
        <p>
          陈岸瑛：教授、博士生导师、哲学博士，清华大学美术学院艺术史论系主任，清华大学艺术学学位评定分委员会委员，清华大学美术学院党委委员、学术委员会委员、教学委员会委员，研究方向为现当代艺术理论、美学、艺术管理。</p>
        <p>邓小鹏：中国美术学院继续教育学院副教授，视觉传达（装潢广告）设计教研室主任。</p>
        <p>
          任志忠：中国美术学院教授，硕士研究生导师，油画系第二工作室主任，2017年进入文化部国家主题性美术创作研究班，参与国家重大题材美术创作的学习和实践。</p>
        <p>
          刘静：博士，教授、硕士生导师。美国阿拉巴马大学传媒与信息科学学院访问学者；中国新闻史学会视听传播专业委员会理事、中国高等院校影视学会会员。擅长影像叙事、新媒体视听艺术、跨文化传播。</p>
        <p>
          舒笑梅：博士，教授，中国传媒大学艺术学部副学部长，曾任国际交流与合作处（港澳台事务办公室）处长、研究生院副院长、外国语学院副院长，兼任中国加拿大研究会常务理事。擅长传媒艺术和跨媒介叙事，2020一2021年主持国家广播电视总局部级社科研究项目“短视频叙事与国家形象传播研究”。</p>
        <p>
          蒋旭峰：教授，硕士生导师，南京艺术学院文化产业学院教授，研究方向：艺术传播、应用传播与广告学；开设媒介产业经营管理、创新思维修炼、研究方法与论文写作、整合营销传播、广告策划与创意等课程。长期主持或参与南京市及周边城市企业的策划：包括
          企业形象与企业文化工程策划；企业整合营销传播策划；企业广告策划；企业销售策划。</p>
        <p>
          顾平：教授，专业带头人，南京艺术学院艺术研究院院长、教授，人文学院艺术教育专业教授。中国美术家协会会员，中国高等美术教育学会常务理事，中国高校美术教师教育联盟主席。主讲艺术专业文献阅读写作、美术史学史、艺术概论、艺术美育等课程。</p>
        <p>
          徐堃：南京艺术学院文化产业学院教师、紫金文创研究院特邀研究员。主要研究方向：文化产业管理、中国艺术经济史。参与文化产业学院及紫金文创研究院横向、纵向课题多项。开设管理学、财务管理、市场营销、文化产业项目管理等。</p>
      </div>
      <!-- 部分师资 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <div class="title-image">入学流程</div>
        <img src="@/assets/images/personRain/mba-flow.png" alt="" class="flow-img"/>
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>本科或同等学历</p>
        <p>专科毕业，拥有三年及以上管理经验</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.中英文申请表</p>
          <p class="apply-text">2.中英文简历</p>
          <p class="apply-text">3.中英文动机信</p>
          <p class="apply-text">4.毕业证复印件及英文翻译件或学信网认证报告及翻译件</p>
          <p class="apply-text">5.身份证原件照片复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片电子版</p>
          <p class="apply-text">7.中文推荐信1封</p>
        </div>
        <!--申请材料-->
      </div>
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <!--      <div class="down-load">-->
      <!--        <p>相关资料下载</p>-->
      <!--        <p class="open-pdf" @click="openPdf">艺术设计与管理硕士</p>-->
      <!--      </div>-->
      <!--      <div style="clear:both;"></div>-->
      <!-- 相关资料下载 -->
    </div>
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->
  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'MadmVue',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    // openPdf() {
    //   window.open('http://cdn.yzvet.com/group1/M00/3F/A9/wKgCEmfksLqACWsYAhzMoveH8as068.pdf', '_blank');
    // }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/madmVue.vue